module.exports = __webpack_public_path__ + "media/images/new_home/instagram-icon-4a1fa4c2a13eb15f9a4ba26e9d813e70.png";